import { Link } from 'react-router-dom'
import { RiArrowRightLine, RiTimeLine } from 'react-icons/ri'
import SEO from '../../components/seo/SEO'
import { breadcrumb } from '../../components/seo/jsonLd'

const POSTS = [
  {
    slug: 'monsoon-haircare-chennai',
    title: 'Monsoon haircare survival guide for Chennai humidity',
    excerpt: 'Frizz, flatness and breakage are the trio nobody asks for. Here is what our colourists actually use at home.',
    category: 'Hair',
    minutes: 5,
    date: '2026-04-22',
    gradient: 'from-salon-primary/20 to-salon-secondary/20',
  },
  {
    slug: 'bridal-skin-prep-90-days',
    title: 'Your 90-day bridal skin prep checklist',
    excerpt: 'A week-by-week roadmap our skin therapists give every bride — peels, hydration plan and the truth about supplements.',
    category: 'Bridal',
    minutes: 8,
    date: '2026-04-12',
    gradient: 'from-salon-secondary/20 to-salon-accent/30',
  },
  {
    slug: 'balayage-vs-highlights',
    title: 'Balayage vs highlights vs ombré — which one suits you?',
    excerpt: 'A simple decision tree from our senior colourist on cost, maintenance and how each looks as it grows out.',
    category: 'Color',
    minutes: 6,
    date: '2026-03-28',
    gradient: 'from-salon-primary-light/20 to-salon-primary/20',
  },
  {
    slug: 'gel-vs-acrylic-nails',
    title: 'Gel vs acrylic vs press-ons — the honest pros & cons',
    excerpt: 'When to choose what, how to care for them, and what to never do at home no matter what TikTok tells you.',
    category: 'Nails',
    minutes: 4,
    date: '2026-03-15',
    gradient: 'from-salon-accent/30 to-salon-cream-dark',
  },
  {
    slug: 'facial-frequency-skin-type',
    title: 'How often should you actually get a facial?',
    excerpt: 'Spoiler: it depends on your skin type, age and what your goals are. We made a cheat sheet.',
    category: 'Skin',
    minutes: 5,
    date: '2026-03-02',
    gradient: 'from-salon-secondary-light/30 to-salon-cream',
  },
  {
    slug: 'hair-spa-vs-keratin',
    title: 'Hair spa vs keratin — what your hair really needs',
    excerpt: 'One nourishes, the other transforms. Our chemists explain the science so you can pick without regret.',
    category: 'Hair',
    minutes: 7,
    date: '2026-02-18',
    gradient: 'from-salon-primary/15 to-salon-primary-dark/30',
  },
]

export default function Blog() {
  return (
    <>
      <SEO
        title="The Salon Vora Journal — Beauty Tips & Trends"
        description="Expert beauty guides from Salon Vora's stylists, colourists, makeup artists and skin therapists. Real advice, no fluff."
        path="/blog"
        jsonLd={breadcrumb([{ name: 'Home', url: '/' }, { name: 'Blog', url: '/blog' }])}
      />

      <div className="min-h-screen bg-salon-cream">
        <section className="relative bg-hero-gradient py-28 overflow-hidden">
          <div className="container-salon relative z-10 text-center">
            <span className="section-tag mb-4 inline-block !text-salon-secondary !bg-salon-secondary/15">The Journal</span>
            <h1 className="font-display text-4xl md:text-6xl text-white font-bold mb-4">
              Beauty Tips, Tricks &amp; <span className="text-salon-secondary italic">Trends</span>
            </h1>
            <p className="text-white/70 font-body max-w-xl mx-auto">
              Honest, practical advice straight from our chair — written by the people who actually do your hair, skin, nails and makeup.
            </p>
          </div>
        </section>

        <section className="py-20 container-salon">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {POSTS.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`}
                className="card group block overflow-hidden">
                <div className={`h-48 bg-gradient-to-br ${p.gradient} flex items-center justify-center`}>
                  <span className="font-display font-bold text-salon-primary/30 text-7xl">
                    {p.title.charAt(0)}
                  </span>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="badge badge-primary">{p.category}</span>
                    <span className="flex items-center gap-1 text-salon-muted text-xs font-body">
                      <RiTimeLine /> {p.minutes} min read
                    </span>
                  </div>
                  <h2 className="font-display font-semibold text-salon-dark text-lg mb-2 line-clamp-2 group-hover:text-salon-primary transition-colors">
                    {p.title}
                  </h2>
                  <p className="text-salon-muted font-body text-sm mb-4 line-clamp-2">{p.excerpt}</p>
                  <div className="flex items-center justify-between">
                    <time className="text-xs font-body text-salon-muted">
                      {new Date(p.date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                    </time>
                    <span className="inline-flex items-center gap-1 text-salon-primary font-semibold text-sm group-hover:gap-2 transition-all">
                      Read <RiArrowRightLine />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container-salon max-w-2xl text-center">
            <h2 className="font-display text-3xl text-salon-dark font-bold mb-3">Get the next post in your inbox</h2>
            <p className="text-salon-muted font-body mb-6">One short, useful beauty email every two weeks. Unsubscribe anytime.</p>
            <form
              className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
              onSubmit={(e) => { e.preventDefault(); alert('Thanks! Subscription is wired up via the API in production.') }}
            >
              <input type="email" required placeholder="you@example.com" className="input-field flex-1" />
              <button type="submit" className="btn-primary">Subscribe</button>
            </form>
          </div>
        </section>
      </div>
    </>
  )
}
